import React, { useEffect, useRef } from 'react';
import anime from 'animejs';

// Wrap children in a button-sized div; cursor pulls it slightly.
const Magnetic = ({ children, className = '', strength = 0.25 }) => {
    const ref = useRef(null);

    useEffect(() => {
        const el = ref.current;
        if (!el) return;

        const onMove = (e) => {
            const r = el.getBoundingClientRect();
            const x = (e.clientX - (r.left + r.width / 2)) * strength;
            const y = (e.clientY - (r.top + r.height / 2)) * strength;
            anime({ targets: el, translateX: x, translateY: y, duration: 300, easing: 'easeOutQuad' });
        };
        const onLeave = () => {
            anime({ targets: el, translateX: 0, translateY: 0, duration: 500, easing: 'easeOutElastic(1, .6)' });
        };

        el.addEventListener('pointermove', onMove);
        el.addEventListener('pointerleave', onLeave);
        return () => {
            el.removeEventListener('pointermove', onMove);
            el.removeEventListener('pointerleave', onLeave);
        };
    }, [strength]);

    return (
        <span ref={ref} className={`inline-block ${className}`}>
            {children}
        </span>
    );
};

export default Magnetic;
